export default __webpack_public_path__ + "static/media/ProfileIcon.7dd46742.png";